import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_14 = { class: "indicator-label" }
const _hoisted_15 = { class: "indicator-progress" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_ctx.can('update', 'registered-trades'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('pulleRegisteredTradesScraping')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSubmitCreate()), ["prevent"])),
            model: _ctx.formData,
            ref: "submitButton"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('selectDate')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Field, {
                        type: "month",
                        modelValue: _ctx.formData.dateRange,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dateRange) = $event)),
                        name: "date",
                        placeholder: _ctx.translate('pickaMonth'),
                        class: "form-control form-control-lg form-control-solid"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_ErrorMessage, { name: "transactionDate" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-white btn-active-light-primary me-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, _toDisplayString(_ctx.translate('discard')), 1),
            _createElementVNode("button", {
              type: "submit",
              id: "kt_account_profile_details_submit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmitCreate())),
              ref: "submitButton",
              class: "btn btn-primary"
            }, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate('saveChanges')), 1),
              _createElementVNode("span", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                _hoisted_16
              ])
            ], 512)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}